export default __webpack_public_path__ + "static/media/male.b544f526.jpeg";